import { render } from "./SelectText.vue?vue&type=template&id=5df604d8&scoped=true&ts=true"
import script from "./SelectText.vue?vue&type=script&lang=ts"
export * from "./SelectText.vue?vue&type=script&lang=ts"

import "./select-input.scss?vue&type=style&index=0&id=5df604d8&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5df604d8"]])

export default __exports__